/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
      this.querySelectorAll('table').forEach(this.#formatTable);

      // Wrap YouTube/Vimeo iframes in a video-wrapper div
      this.querySelectorAll('iframe').forEach(this.#formatIframe);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  #formatIframe(iframe){
      const src = iframe?.src ?? "";
    if (
      src.indexOf('youtube') !== -1 ||
      src.indexOf('youtu.be') !== -1 ||
      src.indexOf('vimeo') !== -1
    ) {
      const wrapper = document.createElement('div');
      wrapper.className = 'video-wrapper';
      iframe.parentNode?.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
